var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.927246H513V342.894H0V0.927246Z",
    fill: "#003E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.41 291.293C327.204 291.293 380.542 237.956 380.542 172.161C380.542 106.366 327.204 53.0288 261.41 53.0288C195.615 53.0288 142.277 106.366 142.277 172.161C142.277 237.956 195.615 291.293 261.41 291.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.412 88.6807C215.089 88.6807 176.727 127.043 176.727 174.365C176.727 221.688 215.089 260.05 262.412 260.05C309.734 260.05 348.096 221.688 348.096 174.365C348.096 127.043 309.734 88.6807 262.412 88.6807ZM158.727 174.365C158.727 117.102 205.148 70.6807 262.412 70.6807C319.675 70.6807 366.096 117.102 366.096 174.365C366.096 231.629 319.675 278.05 262.412 278.05C205.148 278.05 158.727 231.629 158.727 174.365Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.412 152.723L211.713 176.169V196.208C211.713 208.031 217.825 219.052 227.944 225.164L262.512 240.394L297.079 225.164C307.099 218.952 313.311 208.031 313.311 196.208V176.169L262.412 152.723Z",
    fill: "#003E87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.411 152.172L313.811 175.849V196.208C313.811 208.207 307.506 219.288 297.343 225.589L297.313 225.608L262.512 240.94L227.713 225.609L227.686 225.592C217.414 219.388 211.213 208.203 211.213 196.208V175.849L262.411 152.172ZM262.412 153.274L212.213 176.488V196.208C212.213 207.848 218.225 218.697 228.175 224.72L262.512 239.848L296.845 224.721C306.703 218.595 312.811 207.843 312.811 196.208V176.489L262.412 153.274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.713 129.277H313.211V176.069H211.713V129.277Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.213 128.777H313.711V176.569H211.213V128.777ZM212.213 129.777V175.569H312.711V129.777H212.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.927246H513V35.9956H0V0.927246ZM0 307.525H513V342.593H0V307.525Z",
    fill: "#CE1127"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.927246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/BZ.7b9d2f9d7f0c900c7e19655f3a606272.svg";
export { ForwardRef as ReactComponent };